<div class="product-variant" [dir]="direction.isRTL() ? 'rtl' : 'ltr'">
    <a appClick [routerLink]="getProductLink()" class="image">
        <img [src]="getThumbnail()">
    </a>
    <a appClick [routerLink]="getProductLink()" class="text">
        <div class="product-name mb-1">{{translateHelper.localize(product.name)}}</div>
        <ng-container *ngIf="!product?.isOnlyQuotation && !product.isOfferable">
            <div class="product-card__prices mt-0">
                <ng-container *ngIf="product.taxedPrice < product.baseTaxedPrice ">
                    <div class="product-card__old-price">{{ product.baseTaxedPrice || product.price|currencyConvert : product.companyData.currencyMeta.code }}</div>
                    <span class="product-card__new-price">{{ product.taxedPrice|currencyConvert : product.companyData.currencyMeta.code }}</span>{{ ' ' }}
                </ng-container>
                <ng-container *ngIf="product.taxedPrice >= product.baseTaxedPrice">
                    {{ product.taxedPrice || product.price|currencyConvert : product.companyData.currencyMeta.code }}
                </ng-container>
                <small class="font-weight-bold" *ngIf="product?.realEstate?.displayPrice?.propertyType =='rent' && product?.realEstate?.displayPrice?.rentType">
                    / {{product?.realEstate?.displayPrice?.rentType|uppercase}}
                </small>
            </div>
            <ng-container *ngIf="product?.vat == 'I' || product?.vat == 'E'">
                <span style="font-size: x-small;" class="my-2">{{"inclusive"|translate}}</span>
            </ng-container>
        </ng-container>
    </a>
    <ng-container *ngIf="viewAddtoCart() && product.layout != 'property';">
        <div class="controls">
            <div class="quantity-input">
                <app-input-number-new aria-label="Quantity" class="product__quantity-availability" [min]="(product.quantity?.min) ? product.quantity?.min : 1" [max]="product.quantity?.max" [step]="product.quantity?.step" [formControl]="amount"></app-input-number-new>
            </div>
            <button eventCollector eventName="add_to_cart" category="catalog" [companyId]="product.companyData?._id" [itemType]="product.type" [itemId]="product._id" class="btn btn-primary px-3" type="button" appClick (click)="addToCart()" [ngClass]="{'btn-loading': addingToCart}">
                <mat-icon>add_shopping_cart</mat-icon>
            </button>
        </div>
    </ng-container>
</div>